
/* eslint-disable */
const CryptoJS = require("crypto-js");
// let gdp: any

const app: AppInfo = {
    goods_name: '',
    goods_id: '',
    merchant_code: '',
    merchant_name: '',
    aes_key: '',
    project_id: '',
    data_source_id: '',
    host: ''
}

const setAppInfo = (info: AppInfo) => {
    app.goods_name = info.goods_name
    app.goods_id = info.goods_id
    app.merchant_code = info.merchant_code
    app.merchant_name = info.merchant_name
    app.aes_key = info.aes_key
    app.data_source_id = info.data_source_id
    app.project_id = info.project_id
    app.host = info.host
    init()
}

const aesEncode = (data: string): string => {
    if(!data) {
        return data
    }
    
    //密钥必须是16位，且避免使用保留字符
    let key = CryptoJS.enc.Utf8.parse(app.aes_key);
    let encryptedData = CryptoJS.AES.encrypt(data, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    // let hexData = encryptedData.ciphertext.toString();
    let hexData =  CryptoJS.enc.Base64.stringify(encryptedData.ciphertext)
    // console.log({data, hexData})
    // return Base64.encode(hexData)
    return hexData
}
const init = () => {
    const gdp = window.gdp
    if (!gdp) {
        setTimeout(() => {
            init()
        }, 2000)
        return
    }

    window.gdp('init', app.project_id, app.data_source_id, {
        host: app.host, // 数据发送地址
        compress: true, // 开启数据压缩模式
        hashtag: true, // 开启页面 URL混淆采集
        debug: app.host.indexOf('uta')>=0, // 开启测试模式, 控制台可看到数据
    })
    setAttr()
    pageView()
    window.gdp('send')
}

/**
 * 设置用户ID采集, 需要在 init 后调用
 * @param encodePhone base64 加密后的手机号
 */
const setUserId = (encodePhone: string) => {
    window.gdp('setUserId', encodePhone)
    setAttr()
}

const send = () => {
    window.gdp('send')
}


const setAttr = () => {
    window.gdp('setUserAttributes', {
        "operatiirs_var": "移动",
        "prov_var": "广东", // 赋值身份名称
        "city_var": "广州" // 赋值地市名称
    })
}


const pageView = ()=>{
    window.gdp('track', "merchants_pageView", {
        "pageName_var": document.title, // ⻚⾯访问时当前⻚⾯名称。
        "merchantsId_var": app.merchant_code, // 商品所属商⼾id。
        "merchants_var": app.merchant_name, // 商品所属商⼾名称。
    })
}
/**
 * merchants_bussinessProcessing
 * 业务办理与支付流程（前端
 * @param eventName 事件名 页面浏览、输入姓名(点击输入框时触发）、输入联系电话(点击输入框时触发）、输入身份证(点击输入框时触发）、选择收货省/市（选择成功后触发）、填写详细地址(点击输入框时触发）、提交订单、提交订单成功、提交订单失败......以放号各页面上的具体办理步骤为准
 * @param contactNo 联系电话
 * @param orderId 订单号
 */
const bussiness = (isCmcc: boolean, eventName: string, contactNo: string, orderId: string, err: string = '') => {
    const data = {
        "businessType_var": "放号", // 业务类型 属于存量业务则写 "存量"
        "goodsType_var": "号卡", // 商品类型
        "goodsName_var": app.goods_name, // 商品名称 业务办理时商品名称
        "goodsId_var": app.goods_id, //商品ID 业务办理时所属的商品ID
        "skuName_var": app.goods_name, // sku名称 29元、39元…..
        "skuId_var": app.goods_id, // skuID 业务办理时的 skuId
        "merchants_var": app.merchant_name, // 商户名称 商品所属商户名称
        "merchantsId_var": app.merchant_code,// 商户id 商品所属商户ID
        "apiName_var": "线上放号订单下单接口", // 接口名称 调用接口名称
        "apiId_var": "AirpickinstallnewOrder",// 接口id 调用接口 id
        "iop_tacticsId_var": "", // IOP策略ID 页面访问时当前页面对应的 IOP 策略ID号 - 物品模型
        "referFlowId_var": "",// 来源位置ID 页面访问时当前页面运营位ID
        "contactNumber_var": aesEncode(contactNo + ''),//联系电话 输入的电话号码 AES 加密后的值
        "processType_var": eventName, // 办理步骤: 页面浏览、输入姓名(点击输入框时触发）、输入联系电话(点击输入框时触发）、输入身份证(点击输入框时触发）、选择收货省/市（选择成功后触发）、填写详细地址(点击输入框时触发）、提交订单、提交订单成功、提交订单失败......以放号各页面上的具体办理步骤为准
        "errorMessage_var": err, // 失败原因
        "payType_var": "", // 支付方式
        "orderNumber_var": orderId, // 订单号
        "ordertype_var": "号卡订单", // 订单类型
    }
    // console.log({ eventName, contactNo, orderId, err })
    if(isCmcc) {
        window.gdp('track', "merchants_bussinessProcessing", data);
    }
}

export default {
    setUserId,
    // send,
    setAppInfo,
    bussiness,
}